export const normalizeDisplayLabel = (value: unknown): string => {
  if (value === null || value === undefined) {
    return "";
  }

  return String(value).replace(/_/g, " ").replace(/ {2,}/g, " ");
};

export const normalizeDisplayLabelWithoutUndefined = (
  value: unknown,
): string => {
  return normalizeDisplayLabel(value)
    .replace(/\bundefined\b/gi, "")
    .replace(/ {2,}/g, " ")
    .trim();
};
